/** Business timezone contract — must match ris-backend `ANALYTICS_TIMEZONE`. */
export const ANALYTICS_TIMEZONE = 'Asia/Kolkata';

function daysInMonth(year: number, month: number): number {
  return new Date(year, month, 0).getDate();
}

function getZonedParts(instant: Date, timeZone: string) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })
      .formatToParts(instant)
      .filter(p => p.type !== 'literal')
      .map(p => [p.type, p.value])
  );
  return {
    y: Number(parts.year),
    mo: Number(parts.month),
    d: Number(parts.day),
  };
}

/** Today as YYYY-MM-DD in the analytics business timezone. */
export function analyticsTodayIso(timeZone: string = ANALYTICS_TIMEZONE): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

/** Calendar day N days before today in the analytics business timezone. */
export function analyticsDaysAgoIso(days: number, timeZone: string = ANALYTICS_TIMEZONE): string {
  const { y, mo, d } = getZonedParts(new Date(), timeZone);
  let year = y;
  let month = mo;
  let day = d;
  let remaining = Math.max(0, Math.floor(days));

  while (remaining > 0) {
    if (day > remaining) {
      day -= remaining;
      remaining = 0;
    } else {
      remaining -= day;
      month -= 1;
      if (month < 1) {
        month = 12;
        year -= 1;
      }
      day = daysInMonth(year, month);
    }
  }

  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
